<template>
  <!-- 注册界面 -->
  <div id="Register">
    <!-- 注册界面 -->
    <div class="header">
      <div>
        <a
          title="登录海星云云游戏平台,海星云,云游戏,海星云云平台,海星云云游戏"
          class="fl logo"
        >
          <img
            draggable="false"
            src="../../static/images/logo/logo1.png"
            alt="海星云,云游戏,海星云云平台,海星云云游戏"
          />
        </a>
        <a class="fr Return" title="海星云,云游戏,海星云云平台,海星云云游戏">
          <span
            @mouseenter="Returnasdf"
            @mouseleave="Returna"
            @click="Returngo"
          >
            <img draggable="false" :src="Return" alt="返回首页" />返回
          </span>
        </a>
      </div>
      <p>海星云云游戏平台</p>
    </div>
    <div>
      <!-- <div style="display:block;width:62.5rem;margin:0 auto">
                <img src="../../static/images/zhuce/1.jpg" alt="" style= "width:100%;height:18.75rem;">
      </div>-->
      <div class="signIn">
        <!-- 手机号 -->
        <div class="from">
          <div class="input">
            <p class="fl">
              手机号码/
              <i style="color: red">用做于登录时用户名</i>
            </p>
            <div>
              <input
                type="text"
                class="inputm fl"
                :class="[phone == false ? 'inputm' : 'inputh']"
                placeholder="请输入手机号码"
                @blur="phonea"
                v-model="shuru.phone"
              />
              <span>{{ cuowuspan.phone }}</span>
            </div>
          </div>
          <!-- 滑块 -->
          <div class="input">
            <p class="fl"></p>
            <div id="your-dom-id" class="nc-container fl"></div>
          </div>
          <!-- 验证码 -->
          <div class="input">
            <p class="fl">验证码</p>
            <div>
              <input
                type="text"
                class="inputm fl"
                style="width: 120px"
                :class="[Verification == false ? 'inputm' : 'inputh']"
                placeholder="请输入六位验证码"
                @blur="Verificationa"
                v-model="shuru.Verification"
              />
              <button
                style="
                  border: 1px solid #dfdfdf;
                  width: 100px;
                  height: 40px;
                  background: #356ded;
                  color: #dfdfdf;
                  border-radius: 5px;
                "
                :disabled="disabled"
                @click="send"
              >
                {{ sends }}
              </button>
              <span>{{ cuowuspan.Verification }}</span>
            </div>
          </div>

          <!-- 密码 -->
          <div class="input">
            <p class="fl">密码</p>
            <div>
              <input
                type="password"
                class="inputm fl"
                :class="[pass == false ? 'inputm' : 'inputh']"
                placeholder="请输入数字字母8~25位密码"
                @blur="passa"
                v-model="shuru.pass"
                autocomplete="new-password"
              />
              <span>{{ cuowuspan.pass }}</span>
            </div>
          </div>
          <!-- 二次密码 -->
          <div class="input">
            <p class="fl">确认密码</p>
            <div>
              <input
                type="password"
                class="inputm fl"
                :class="[password == false ? 'inputm' : 'inputh']"
                placeholder="请再次确认密码"
                @blur="passworda"
                v-model="shuru.password"
                autocomplete="new-password"
              />
              <span>{{ cuowuspan.password }}</span>
            </div>
          </div>
          <!-- 邮箱 -->
          <div class="input">
            <p class="fl">邮箱</p>
            <div>
              <input
                type="text"
                class="inputm fl"
                :class="[email == false ? 'inputm' : 'inputh']"
                placeholder="请输入邮箱"
                @blur="emaila"
                v-model="shuru.email"
              />
              <span>{{ cuowuspan.email }}</span>
            </div>
          </div>
          <!-- 姓名 -->
          <!-- <div class="input">
                        <p class="fl" >真实姓名</p>
                        <div>
                            <input type="text" class="inputm fl" :class="[name==false?'inputm':'inputh']"  placeholder="请输入真实姓名" @blur="namea" v-model="shuru.name">
                            <span>{{cuowuspan.name}}</span>
                        </div>
                    </div>
                    <ul>
                        <li>为了更好的平衡游戏与生活，同时响应文化部《网络游戏管理暂行办法》要求，云用户需要使用真实姓名、有效身份证号码实名认证才能注册海星云平台。</li>
                        <li>请填写真实的姓名、身份证号码等信息，信息如若虚假后续将无法进行身份人脸识别验证。</li>
                        <li>注册成功并通过后续身份人脸识别验证的用户可免费体验60分钟。</li>
          </ul>-->
          <!-- 身份证号 -->
          <!-- <div class="input">
                        <p class="fl" >身份证号</p>
                        <div>
                            <input type="text" class="inputm fl" :class="[idcard==false?'inputm':'inputh']"  placeholder="请输入有效身份证号码" @blur="idcarda" v-model="shuru.idcard">
                            <span>{{cuowuspan.idcard}}</span>
                            <p class="fangchenmi">
                                <i class="fl">实名防沉迷信息填写</i>
                                <a  title="实名认证"><i class="fr" style="color:red" @mousemove="whya" @mouseleave="whyb">为什么要填写</i></a>
                                <span v-if="why" class="why">
                                    根据《网络游戏管理暂行办法》，
                                    网络游戏用户需使用有效的身份证件进行实名注册。
                                    为保证流畅游戏体验，
                                    享受健康游戏生活，请广大用户实名注册。
                                </span>
                            </p>
                        </div>
          </div>-->
          <!-- 邀请码 -->
          <div class="input">
            <p class="fl">邀请码(选填)</p>
            <div>
              <input
                type="text"
                class="inputm fl"
                :class="[invitation == false ? 'inputm' : 'inputh']"
                placeholder="请输入有效邀请码"
                @blur="invitationa"
                v-model="shuru.invitation"
                :disabled="yaoqm"
              />
              <span>{{ cuowuspan.invitation }}</span>
            </div>
          </div>
        </div>
        <!-- 协议 -->
        <div class="checkboxa" @click="xieyi">
          <input
            type="checkbox"
            class="fl"
            :checked="checked"
            @click.stop="check"
          />
          <p class="fl">
            用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。
            用户的使用、登录等行为即视为您已阅读并同意本协议的约束。
            <a
              style="text-decoration: underline; color: #e60012"
              @click.stop="zhucexy"
              title="《星瀛科技在线服务协议》"
              >《星瀛科技在线服务协议》</a
            >
          </p>
        </div>
        <div class="Registerbtn">
          <a
            :class="[checked == true ? 'Registerbtnl' : 'Registerbtnm']"
            @click="Register"
            >注册</a
          >
          <!-- <p>实名认证一小时内可认证三次，一天内可认证五次，认证不通过则无法注册。</p> -->
        </div>
      </div>
    </div>
    <!-- 注册协议 -->
    <div id="xykjxieyi" v-show="zhucexieyi">
      <div class="xieyi">
        <h3>
          星瀛科技（北京）有限公司
          <br />关于海星云平台的使用及付费服务协议
        </h3>
        导言：
        <br />
        <br />欢迎您使用星瀛科技（北京）有限公司平台提供的网站、软件及服务！
        星瀛科技（北京）有限公司（以下称为“星瀛科技”）系网站www.haixingcloud.com及海星云平台的运营商，为保障用户正常使用星瀛科技（北京）有限公司（以下简称
        “星瀛科技”）提供的网站、软件及服务（以下成为“本服务”），用户需阅读并遵守《星瀛科技关于海星云平台的的使用及付费服务协议》（以下简称“本协议”）。
        用户在使用星瀛科技提供的各项服务之前，应仔细阅读本协议，如用户不同意本服务协议及/或随时对其的修改，请停止使用星瀛科技提供的服务。
        <br />同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称“网络服务”)，为获得网络服务，服务使用人(以下称“用户”)同意本协议的全部条款并按照页面上的提示完成全部的注册程序。
        <br />
        <br />
        <p style="color: red">
          用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。
          用户的使用、登录等行为即视为您已阅读并同意本协议的约束。
        </p>
        <br />本协议下的条款可由星瀛科技随时变更，用户须定期审阅本协议。协议条款一旦发生变动，星瀛科技将会在本页面进行更新，并在星瀛科技相关的页面上提示变更内容。变更后的协议一经公布即有效代替原来的协议。用户如不同意星瀛科技对本协议所作的任何变更，应立即停止使用星瀛科技提供的星瀛科技网站、软件及服务。如用户在本协议变更后继续使用星瀛科技网站、软件及服务，即视作用户已完全同意变更后的协议。用户可随时在本页面查阅最新付费服务及充值规则。
        <br />用户有违反本协议的任何行为时，星瀛科技有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
        <br />如果用户未满18周岁，请在监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。
        <br />一、定义 <br />1.1星瀛科技：指星瀛科技（北京）有限公司。
        <br />1.2网站、软件及服务：指星瀛科技提供的网站、软件及服务。
        <br />1.3用户：指启用、浏览或上传数据至星瀛科技海星云平台服务的用户，在本协议中更多地称为“您”。
        <br />1.4其他用户：指除用户本人外与星瀛科技平台服务相关的其他星瀛科技用户。
        <br />1.5法律法规：指用户所属/所处地区、国家现行有效的法律、行政法规、司法解释、地方法规、地方规章、部门规章及其他规范性文件以及对于该等法律法规的不时修改和补充，以及相关政策规定等
        <br />二、协议的范围
        <br />2.1本协议是您与星瀛科技之间关于您在下载、安装、使用、复制本平台、软件和网站中涉及付费服务和充值规则等相关事宜所订立的协议。
        <br />2.2本协议内容同时包括星瀛科技可能不断发布的关于付费服务和充值规则的相关协议、服务声明、业务规则及公告指引等内容（以下统称为“专项规则”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
        <br />三、用户身份信息验证
        <br />3.1您在申请海星云账号过程中，需要填写一些必要的信息，请保持这些信息的及时更新，以便星瀛科技向您提供帮助，或更好地为您提供服务。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整或不准确，则可能无法使用服务或在使用过程中受到限制。
        <br />3.2星瀛科技与用户一同致力于个人信息的保护，保护用户个人信息是星瀛科技的一项基本原则。未经您的同意，星瀛科技不会向星瀛科技以外的任何公司、组织或个人披露您的个人信息，但法律法规另有规定的除外。
        <br />四、使用规则
        <br />4.1用户承诺以其真实身份注册成为星瀛科技的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法令规定和本协议约定对所提供的信息承担相应的法律责任。星瀛科技有权审查用户注册所提供的身份信息是否真实、有效。用户以其真实身份注册成为星瀛科技用户后，需要修改所提供的个人身份资料信息的，星瀛科技应当及时、有效地为其提供该项服务。若用户所提供的资料与事实不符或所提供的资料已变更而未更新或有任何误导之嫌导致星瀛科技无法为用户提供或进一步提供服务，星瀛科技不因此承担任何责任。
        <br />4.2用户注册成功后，星瀛科技将给予每个用户一个用户账号及相应的密码。该用户账号和密码由用户负责保管。用户有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码，并对登录后所持账号产生的行为依法享有权利和承担责任。星瀛科技应积极地采取技术与管理等合理措施保障用户账号的安全、有效。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给用户和他人的民事权利造成损害的，应当承担由此产生的法律责任。鉴于网络服务的特殊性，星瀛科技无义务审核是否用户本人使用该组账号及密码，仅审核账号及密码是否与数据库中保存的一致，只要任何人输入的账号及密码与数据库中保存的一致，即可凭借该组账号及密码登录并获得网络服务，所以即使用户认为其所有的账号登录行为并非其本人所为，星瀛科技将不承担因此而产生的任何责任。
        <br />4.3用户发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据星瀛科技公布的处理方式通知星瀛科技，并有权通知星瀛科技采取措施暂停该账号的登录和使用,用户可发送相关信息至
        service@starvictory.com或直接联系客服人员，进行举证通知。星瀛科技在收到用户要求采取措施暂停其账号登录和使用的通知后，应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息。星瀛科技核实用户所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账号的登录和使用。用户提供其个人有效身份证件与所注册的身份信息一致的，有权及时采取措施暂停用户账号的登录和使用。用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，星瀛科技有权拒绝用户前述请求，用户应当自行承担相应损失。
        <br />4.4用户为了维护其合法权益，向星瀛科技提供与所注册的身份信息相一致的个人有效身份信息时，星瀛科技应当为用户提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。
        <br />4.5用户同意接受星瀛科技通过电子邮件或其他方式向用户发送的商品促销或其他相关商业信息。
        <br />4.6用户在使用星瀛科技服务过程中，必须遵循以下原则：
        <br />4.6.1遵守中国有关的法律和法规；
        <br />4.6.2遵守所有与网络服务有关的网络协议、规定和程序；
        <br />4.6.3发现任何非法使用用户账号或账号出现安全漏洞的情况，应立即通告星瀛科技。
        <br />4.7禁止用户在接受网络服务过程中进行以下侵害行为，包括但不限于：
        <br />4.7.1违反宪法确定的基本原则的；
        <br />4.7.2危害国家统一、主权和领土完整的；
        <br />4.7.3泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；
        <br />4.7.4煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；
        <br />4.7.5宣扬邪教、迷信的；
        <br />4.7.6散布谣言，扰乱社会秩序，破坏社会稳定的；
        <br />4.7.7宣扬淫秽、色情、赌博、非法彩票、暴力，或者教唆犯罪的；
        <br />4.7.8侮辱、诽谤他人，侵害他人合法权益的；
        <br />4.7.9违背社会公德的；
        <br />4.7.10有法律、行政法规和国家规定禁止的其他内容的。
        <br />4.8禁止用户进行以下侵害网络服务安全性的行为，包括但不限于：
        <br />4.8.1以任何形式违反诚实信用原则，直接或间接采取组织、教唆、窃取、占有、使用、捡取、购买、转卖等手段侵犯任何第三方拥有使用权的账号、角色、虚拟货币、虚拟物品、虚拟道具等权益；
        <br />4.8.2以任何积极或消极的形式协助他人侵犯第三方权益的；
        <br />4.8.3禁止用户利用网络服务无关的行为，包括但不限于：
        <br />4.8.3.1为任何非法目的及与星瀛科技提供服务或产品未有直接关系而使用网络服务系统；包括但不限于买卖号、角色、虚拟货币、虚拟道具、虚拟物品，宣传赌博、非法彩票等；
        <br />4.8.3.2未经星瀛科技授权访问或试图访问与星瀛科技提供的网络服务相关的任何账户、计算机或网络；
        <br />4.8.3.3未经星瀛科技授权利用星瀛科技提供的相关网络服务以任何方式收集任何其它用户的信息，包括但不限于用户的个人身份信息和通讯信息；
        <br />4.8.3.4接收或下载由其他星瀛科技用户传输的用户所知道或应当知道不能以此方式合法传播的任何材料；
        <br />4.8.3.5利用星瀛科技提供的相关网络服务进行任何可能对互联网的正常运转造成不利影响的行为，包括但不限于以任何方式传输含有计算机病毒、破坏性程序的文件或其他任何可能对他人计算机或互联网的正常运转造成不利影响的软件或程序；
        <br />4.8.3.6利用星瀛科技提供的相关网络服务传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；
        <br />4.8.3.7利用星瀛科技提供的相关网络服务进行任何不利于星瀛科技的行为；
        <br />4.8.3.8利用星瀛科技服务系统进行任何洗钱、购买和销售非法取得虚拟货币等违法行为；
        <br />4.8.3.9就星瀛科技及合作商业伙伴的服务、产品、业务咨询应采取相应机构提供的沟通渠道，在公众场合发布有关星瀛科技及相关服务的负面宣传。
        <br />4.9用户使用根据本协议获得的用户账号和密码登录星瀛科技的网站或接受其他星瀛科技提供的服务项目时，应遵守该网站或服务项目的相关服务协议及使用守则，用户登录上述网站或接受上述服务项目时即视为对相关服务协议及使用守则的接受。
        <br />五、用户信息保护
        <br />5.1保护用户（特别是未成年人）的隐私是星瀛科技的一项基本政策，因此，若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用本服务，必须以父母（监护人）名义申请注册，在接受本服务时，应以法定监护人身份加以判断本服务是否符合于未成年人。
        <br />5.2在不透露单个用户隐私资料的前提下，星瀛科技有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。尽管对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。
        <br />5.3未经用户许可星瀛科技不得向任何第三方公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：
        <br />5.3.1用户或用户监护人授权星瀛科技披露的；
        <br />5.3.2有关法令要求星瀛科技披露的；
        <br />5.3.3司法机关或行政机关基于法定程序要求星瀛科技提供的；
        <br />5.3.4星瀛科技为了维护自己合法权益而向用户提起诉讼或者仲裁时；
        <br />5.3.5应用户监护人的合法要求而提供用户个人身份信息时；
        <br />5.3.6为维护社会公众的利益。 <br />六、付费服务及充值规则
        <br />6.1您理解并同意，星瀛科技有权免费或要求付费提供本服务；本服务收取的充值金额是星瀛科技为了向最终用户收取互联网增值服务使用费，而提供的一种通用的收费渠道或计费方式。该充值金额不能用于本服务以外的任何产品或服务。
        <br />6.2您理解并同意，星瀛科技有权自行决定并不时修订本服务相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本协议的有效组成部分。星瀛科技可能根据实际需要对收费服务的收费标准、方式进行修改和变更，也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，星瀛科技将在相应服务页面进行通知或公告。如您不同意前述标准、规则及其修订，您有权停止使用本服务。您继续使用本服务即视为您同意相关内容。
        <br />6.3本平台的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关规则。星瀛科技会在相关页面上做出提示，如果您拒绝支付该等费用，则不能使用相应的网络服务。
        <br />6.4星瀛科技将有权决定所提供服务的资费标准和收费方式，星瀛科技可能会就不同的服务制定不同的资费标准和收费方式，也可能按照星瀛科技所提供的服务的不同阶段确定不同的资费标准和收费方式。
        <br />6.5充值
        <br />6.5.1在本平台支付系统中，用户通过所用客户端（包括但不限于手机、网站及其他第三方支付渠道）相应支付方式（具体支付方式请见充值页面）为其账号充值所直接获得的虚拟货币即为“海星点”，仅可在本平台使用。1海星点=2元人民币。
        <br />6.5.2本平台支付系统会不时更新发布活动，包括但不限于充值人民币送海星点
        <br />6.5.3海星点可以用于支付接入本平台支付系统的所有互联网应用及内容（包括第三方）的费用。一旦用户用其账号进入第三方企业的服务系统，则支付系统会自动通过和第三方企业的技术合作，将该账号所剩余的海星点以可以消费的该第三方系统自身的结算工具显示给用户；一旦用户退出该第三方服务系统，则在本平台支付系统中仍然可以显示尚未消费的海星点。
        <br />6.5.4用户理解并知晓，星瀛科技不提供用户间交易海星点的平台化服务。用户间交易海星点构成对本协议的违反，星瀛科技有权在未经通知的情况下，采取相应适当措施，以确保星瀛科技不提供用户间交易海星点的平台化服务。
        <br />6.5.5用户理解并同意，充值产品虚拟货币不适用无理由退换，充值一旦成功，充值即确定完成，星瀛科技将不提供任何更改、修正服务。用户不得以消费完成后账户内仍有剩余海星点为由要求退费。
        <br />6.5.6当用户在本平台进行充值时，用户必须仔细确认自己的账号及信息，若因为用户自身操作不当、不了解或未充分了解充值计费方式等因素造成充错账号、错选充值种类等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。
        <br />6.5.7用户在充值时使用第三方支付企业提供的服务的，应当遵守与该第三方的各项协议及其服务规则；在使用第三方支付服务过程中用户应当妥善保管个人信息，包括但不限于银行卡账号、密码、验证码等；用户同意并确认，星瀛科技对因第三方支付服务产生的纠纷不承担任何责任。
        <br />6.5.8若因违反本协议条款，导致账号被冻结及/或终止使用的用户，不得因此要求星瀛科技作任何补偿或赔偿。
        <br />6.5.9若因本平台充值系统自身充值故障原因造成用户充值失实，在星瀛科技恢复、存有有效数据和用户提供合法有效凭证的情况下，星瀛科技将根据用户充值情况做出变动及补救措施。
        <br />6.5.9.1因本平台充值系统自身故障原因，造成系统充值额小于用户实际充值额的，星瀛科技予以补其差额。
        <br />6.5.9.2因本平台充值系统自身故障原因，造成系统充值额大于用户实际充值额的，星瀛科技有权追回差额。
        <br />6.5.9.3海星点是在本平台专用的虚拟货币，用于包括但不限于游玩消耗等网络服务。鉴于本平台提供的网络服务或商品性质特殊，因此，使用海星点在本平台上购买的网络服务或商品属于不宜退货的商品，不适用无理由退换规定。
        <br />6.5.9.4用户理解并同意，您使用帐户内的海星点订阅产品一旦成功，星瀛科技将不提供任何订单更改、修正服务。非经星瀛科技同意，用户订购付费产品并已支付的海星点，将无法退还；用户订购付费产品并已支付的海星点亦不会因本平台提供的服务中止、中断或付费产品下架而退还。
        <br />6.5.10 海星云【海星点账户】和【赠点账户】说明
        <br />6.5.10.1海星云实际充值金额对应的海星点（2元=1海星点）为【海星点账户】。
        <br />6.5.10.2【海星云赠点账户】为赠送的海星点数，包括但不限于充值赠送、活动赠送、签到赠送、用户转赠、海星云官方补偿点数等。
        <br />6.5.10.3海星云赠点。海星云赠点有效期为1年，充值后赠点可长期有效。
        <br />6.5.10.4海星云平台上的转账功能仅限于使用海星点账户中的点数，赠点账户点数无法转赠他人。同时，转账的点数视为赠送点数，进入对方的赠点账户。
        <br />6.5.10.5用户理解并同意，转赠海星点及赠点不适用无理由退换，转赠一旦成功，即确定完成转赠，海星云将不提供任何更改、修正服务。
        <br />6.5.10.6当用户在本平台进行海星点转赠时，用户必须仔细确认转赠的账号及信息，若因为用户自身操作不当、不了解或未充分了解海星点转赠说明等因素造成赠错账号、错填赠送点数等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。
        <br />6.5.10.7海星云【邀请提现】活动中，被邀请用户充值点数的部分海星点将充进其赠点账户（详情请参阅vip等级说明）。
        <br />11当用户在本平台进行转账时，用户必须仔细确认转赠的账号及信息，若因为用户自身操作不当、不了解或未充分了解转账说明等因素造成赠错账号、错填赠送点数等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。
        <br />
        1海星云【邀请提现】活动中邀请用户获得的提现金额由被邀请充值用户转赠而得，即充值用户中海星点账户属提现金额部分，其对应的海星点数转到充值用户的赠点账户中（2元=1海星点）
        <br />七、未成年人保护
        <br />7.1星瀛科技非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用本服务前，应事先取得您监护人的书面同意。
        <br />7.2依据我国相关法律对于未成年人民事行为效力的规定，为保护未成年人在使用本平台过程中的权益，未成年人在进行星瀛科技充值及消费等行为前，应事先取得您监护人的书面同意。若完成充值行为后，未成年人和/或其监护人主张该充值行为无效的，星瀛科技支持退还相应充值金额，请与本平台客服联系申请退还充值金额。若完成充值行为后进行消费，未成年人和/或其监护人主张该消费行为无效的，星瀛科技不承担退还相应消费金额的责任，亦不得因此要求星瀛科技作任何补偿或赔偿。
        <br />八、通知和送达
        <br />8.1本协议项下所有的通知均可通过重要页面公告、电子邮件、短信或常规的信件传送等方式进行；该通知于发送之日视为已送达收件人。
        <br />九、免责声明 <br />9.1星瀛科技通行证所有者不保证以下事宜：
        <br />9.1.1本服务将符合您的要求；
        <br />9.1.2本服务将不受干扰、及时提供、安全可靠或不会出错。
        <br />十、拒绝提供担保
        <br />10.1用户个人对网络服务的使用承担风险。星瀛科技对以下事宜不作任何类型的担保，不论是明确的或隐含的：
        <br />10.1.1本协议项下星瀛科技提供的相关网络服务将符合用户的要求；
        <br />10.1.2本协议项下星瀛科技提供的相关服务将不受不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、电信部门原因及其他任何网络、技术、通信线路等外界或人为因素的影响；
        <br />10.1.3安装、复制、访问网站、充值、运行客户端软件或以其它方式使用“网络游戏”及/或接受星瀛科技提供的相关服务与任何其他软件不存在任何冲突；
        <br />10.1.4通过星瀛科技网站、网络游戏官方网站及其他相关网络上的链接和标签所指向的第三方的商业信誉及其提供服务的质量。
        <br />十一、服务变更、中断或终止
        <br />11.1如因系统维护或升级的需要而需暂停网络服务，星瀛科技将尽可能事先进行通告。
        <br />11.2
        用户在接受星瀛科技提供的服务时实施不正当行为的，星瀛科技有权终止对用户提供服务，进行封号处理，并在情形严重时，将相关信息移交公安机关。该不当行为包括但不限于使用外挂、进行比特币等数字货币挖矿等违约、违规、违法、违反公序良俗、侵犯星瀛科技或任何第三方之权益等。
        <br />11.3用户在接受星瀛科技服务时实施本协议中有明确约定或属于星瀛科技事先明确告知的应被终止服务的禁止性行为的，星瀛科技有权终止对用户提供服务。
        <br />11.4用户提供虚假注册身份信息，或实施违反本协议的行为，星瀛科技采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满星瀛科技应当及时恢复对用户的服务。
        <br />11.5用户利用星瀛科技服务进行洗钱、预付卡套现、购买和销售非法取得虚拟货币等违法行为的，星瀛科技有权在不事先通知用户的情况下中止或终止部分或全部网络服务的权利。
        <br />十二、客户服务
        <br />12.1如果您对星瀛科技采取的账号的限制、冻结或终止等任何措施有异议或在使用海星云的过程中有其他问题的，均可联系星瀛科技客户服务部门（service@starvictory.com），我们会给予您必要的帮助。
        <br />十三、其他
        <br />13.1您使用本平台即视为您已阅读并同意受本协议的约束。星瀛科技有权在必要时修改本协议条款。您可以在本平台的最新版本中查阅相关协议条款，星瀛科技亦会在本平台内显著地方公示。本协议条款变更后，如果您继续使用本平台，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本平台。
        <br />13.2本协议签订地为中华人民共和国北京市海淀区。
        <br />13.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）
        <br />13.4若您和星瀛科技之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您应同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
        <br />13.5本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
        <br />13.6本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        <br />（正文完） <br />特 别 声 明
        <br />鉴于：我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。
        <br />星瀛科技在此依法做出特别声明如下：
        <br />星瀛科技采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中星瀛科技以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”等形式用语的条款），该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款。
        <br />用户如有任何需要说明条款的要求，请立即停止使用服务，同时立即发送邮件至本平台官方客服人员（邮箱地址：service@starvictory.com），若用户未发送内含说明条款要求的邮件至本平台官方客服人员而选择同意该协议，则双方在此确认星瀛科技已依法履行了根据用户要求对相关条款进行说明的法定义务，星瀛科技已给予用户充足的时间与充分的选择权来决定是否缔结本协议。
        <br />
        用户确认已经充分阅读本协议所有条款，明确理解以上协议条款的含义，完全注意并同意了本协议所有条款的合法性及有效性。
        <div class="btn">
          <button @click="tongyi">同意</button>
        </div>
      </div>
    </div>
    <div class="shifou" v-show="shifou">
      <div class="shifoua"></div>
      <div class="shifoub">
        <p style="font-size: 14px">是否前往个人中心进行实名认证？</p>
        <span
          style="display: block; font-size: 16px; color: red; margin-top: 20px"
          >身份验证成功的用户可获得6海星点赠点。</span
        >
        <div style="margin-top: 20px; overflow: hidden">
          <a
            class="fl"
            style="font-size: 14px; border: 1px solid #dfdfdf; padding: 5px"
            @click="anzhuo"
            >安卓客户端使用手册</a
          >
          <a
            class="fr"
            style="font-size: 14px; border: 1px solid #dfdfdf; padding: 5px"
            @click="ppcc"
            >PC客户端使用手册</a
          >
        </div>
        <div style="margin-top: 20px; padding: 0 30px; overflow: hidden">
          <a
            class="fl"
            style="font-size: 14px; border: 1px solid #dfdfdf; padding: 5px"
            @click="fanhui"
            >仅注册</a
          >
          <a
            class="fr"
            style="font-size: 14px; border: 1px solid #dfdfdf; padding: 5px"
            @click="shiming"
            >实名认证</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: '注册海星云，云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      // 滑块参数
      nc_token: '',
      csessionid: '',
      sig: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,

      shifou: false,
      img: '',
      Return: './../../static/images/icon/Return.png',
      why: false,
      checked: false,
      zhucexieyi: false,
      // 输入的数据
      shuru: {
        phone: '',
        Verification: '',
        pass: '',
        password: '',
        email: '',
        // name:'',
        // idcard:'',
        invitation: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: '',
        pass: '',
        password: '',
        email: '',
        // name:'',
        // idcard:'',
        invitation: ''
      },
      // 标识符
      phone: false,
      Verification: false,
      pass: false,
      password: false,
      email: false,
      // name:false,
      // idcard:false,
      invitation: false,
      // 邀请码禁填
      yaoqm: false,

      sceneaa: ''
    }
  },
  methods: {
    // 跳转使用手册详情页
    anzhuo () {
      this.$router.push({
        path: './manual_details',
        query: {
          manual: 12
        }
      })
    },
    ppcc () {
      this.$router.push({
        path: './manual_details',
        query: {
          manual: 11
        }
      })
    },
    send () {
      this.nc_token = this.$cookieStore.getCookie('nc_token')
      this.csessionid = this.$cookieStore.getCookie('csessionid')
      this.sig = this.$cookieStore.getCookie('sig')
      if (this.shuru.phone == '') {
        this.cuowuspan.phone = '请填写手机号'
        this.phone = true
        return false
      } else if (this.nc_token == '' || this.csessionid == '' || this.sig == '') {
        this.$message.error('请滑动滑块进行人机验证')
        return false
      } else {
        this.http.yzpho(this.shuru.phone).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'true') {
              this.cuowuspan.phone = '该手机号已被注册'
              this.phone = true
              return false
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
            return false
          }
          this.http.send(this.shuru.phone, this.nc_token, this.csessionid, this.sig).then(res => {
            if (res.data.code == 200) {
              if (res.data.message == 'ok') {
                this.$message({
                  message: '验证码已发送到您的手机，请注意查看',
                  type: 'success'
                })
                var that = this
                var resend = setInterval(function () {
                  that.sendstime--
                  if (that.sendstime > 0) {
                    that.sends = that.sendstime + 's后重新获取'
                    that.disabled = true
                  } else {
                    clearInterval(resend)
                    that.sends = '获取验证码'
                    that.sendstime = 60
                    that.disabled = false
                  }
                }, 1000)
              }
            } else if (res.data.code == 400) {
              if (res.data.message == 'failed,unable to get data') {
                this.$message.error('不能获取到数据')
              } else if (res.data.message == 'failed,user phone invalid') {
                this.$message.error('手机号无效')
              } else if (res.data.message == 'failed,afs authenticate invalid') {
                this.$message.error('滑块验证失败')
              }
            } else if (res.data.code == 500) {
              if (res.data.message == 'failed,please retry!') {
                this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
              }
            }
          })
        })
      }
    },
    fanhui () {
      this.shifou = false
      this.$router.push('./Home')
    },
    shiming () {
      this.shifou = false
      this.$router.push('./SignIn')
    },
    Returngo () {
      this.$router.push('./Home')
    },
    Returnasdf () {
      this.Return = './../../static/images/icon/Return1.png'
    },
    Returna () {
      this.Return = './../../static/images/icon/Return.png'
    },
    whya () {
      this.why = true
    },
    whyb () {
      this.why = false
    },
    phonea () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号'
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          this.phone = false
          this.cuowuspan.phone = ''
        } else {
          this.phone = true
          this.cuowuspan.phone = '手机号格式有误'
          return false
        }
        this.http.yzpho(this.shuru.phone).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'true') {
              this.cuowuspan.phone = '该手机号已被注册'
              this.phone = true
              return false
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
            return false
          }
        })
      }
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    passa () {
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入密码'
        this.pass = true
        return false
      } else if (this.shuru.pass) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
        if (reg.test(this.shuru.pass)) {
          this.cuowuspan.pass = ''
          this.pass = false
        } else {
          this.cuowuspan.pass = '密码格式有误'
          this.pass = true
          return false
        }
      }
    },
    passworda () {
      if (this.shuru.password == '') {
        this.cuowuspan.password = '请再次输入密码'
        this.password = true
        return false
      } else if (this.shuru.password == this.shuru.pass) {
        this.cuowuspan.password = ''
        this.password = false
      } else {
        this.cuowuspan.password = '两次密码输入不一致'
        this.password = true
        return false
      }
    },
    emaila () {
      if (this.shuru.email == '') {
        this.cuowuspan.email = '请输入邮箱'
        this.email = true
        return false
      } else if (this.shuru.email) {
        var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        if (reg.test(this.shuru.email)) {
          this.cuowuspan.email = ''
          this.email = false
        } else {
          this.cuowuspan.email = '邮箱格式有误'
          this.email = true
          return false
        }
        this.http.yzemail(this.shuru.email).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'true') {
              this.cuowuspan.email = '该邮箱已被注册'
              this.email = true
              return false
            } else {
              this.cuowuspan.email = ''
              this.email = false
            }
          }
        })
      }
    },
    // namea(){
    //     if(this.shuru.name==""){
    //         this.cuowuspan.name="请输入真实姓名"
    //         this.name=true
    //         return false
    //     }else{
    //         this.cuowuspan.name=""
    //         this.name=false
    //     }
    // },
    // idcarda(){
    //     if(this.shuru.idcard==""){
    //         this.idcard=true
    //         this.cuowuspan.idcard = '请填写身份证号码'
    //         return false
    //     }else if(this.shuru.idcard!=""){
    //         this.idcard=false
    //         this.cuowuspan.idcard = ''
    //         var card = this.$cookieStore.checkID(this.shuru.idcard)
    //         if(card=="0"){
    //             this.idcard=true
    //             this.cuowuspan.idcard = '身份证号码有误'
    //             return false
    //         }else if((this.shuru.idcard).length==18){
    //             this.http.yzidcard(this.shuru.idcard).then(res=>{
    //                 if(res.data.code==200){
    //                     if(res.data.message=="true"){
    //                         this.idcard=true
    //                         this.cuowuspan.idcard = '该身份证号码已被注册'
    //                         return false
    //                     }else{
    //                         this.idcard=false
    //                         this.cuowuspan.idcard = ''
    //                     }
    //                 }
    //             })
    //         }else{
    //             this.idcard=false
    //             this.cuowuspan.idcard = ''
    //         }
    //     }
    // },
    invitationa () {
      if (this.shuru.invitation == '') {
        this.invitation = false
        this.cuowuspan.invitation = ''
        return false
      } else { var reg = /^[0-9a-zA-z—]{9}$/ }
      if (reg.test(this.shuru.invitation)) {
        this.invitation = false
        this.cuowuspan.invitation = ''
      } else {
        this.invitation = true
        this.cuowuspan.invitation = '邀请码格式错误'
        return false
      }
      if (this.shuru.invitation != '') {
        var Invitationq = (this.shuru.invitation).substring(0, 4)
        var Invitationh = (this.shuru.invitation).substring(5, 9)
        this.http.yzyaoqingma(Invitationq + Invitationh).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              this.invitation = true
              this.cuowuspan.invitation = '该邀请码不存在'
              return false
            } else {
              this.invitation = false
              this.cuowuspan.invitation = ''
            }
          }
        })
      }
    },
    // 调取注册接口
    // this.name==true||this.idcard==true||

    Register () {
      if (this.shuru.phone == '' || this.shuru.Verification == '' || this.shuru.pass == '' ||
                this.shuru.email == '' || this.checked == false) {
        return false
      } else if (this.phone == true || this.Verification == true || this.pass == true ||
                this.email == true || this.checked == false) {
        return false
      } else if (this.checked == true) {
        const loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var Invitationq = (this.shuru.invitation).substring(0, 4)
        var Invitationh = (this.shuru.invitation).substring(5, 9)
        this.http.zhuce(this.shuru.phone, this.shuru.Verification, this.shuru.pass, this.shuru.email, Invitationq + Invitationh)
          .then(res => {
            if (res.data.code == 200) {
              loading.close()
              this.$message({
                message: '恭喜您！注册成功',
                type: 'success'
              })
              this.shifou = true
              this.$cookieStore.delCookie('user_sess')
              // this.$router.push("./SignIn"); // 强制切换当前路由 path
            } else if (res.data.code == 400) {
              loading.close()
              if (res.data.message == 'failed,user email invalid') {
                this.$message.error('注册失败，邮箱无效')
              } else if (res.data.message == 'failed,user phone invalid') {
                this.$message.error('注册失败，手机号无效')
              } else if (res.data.message == 'failed,user email already exists') {
                this.$message.error('注册失败，邮箱已存在')
              } else if (res.data.message == 'failed,user phone already exists') {
                this.$message.error('注册失败，手机号已存在')
                // }else if(res.data.message=='failed,user idcard already exists'){
                //     this.$message.error("注册失败，身份证已存在");
                // }else if(res.data.message=='failed,real name verification error'){
                //     this.$message.error("注册失败，实名验证失败");
              } else if (res.data.message == 'failed,verification code is expired') {
                this.$message.error('手机验证码无效或过期')
              } else if (res.data.message == 'failed,refreshing too ofen') {
                this.$message.error('您点击的过快，请稍后再试！')
              } else if (res.data.message == 'failed,unable to get data') {
                this.$message.error('无法获取数据')
              }
            }
          })
      }
    },
    // 注册协议页面同意按钮
    tongyi () {
      if (this.checked == false) {
        this.checked = true
      }
      this.zhucexieyi = false
    },
    xieyi () {
      if (this.checked == false) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    check () {
      if (this.checked == false) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    // 注册协议
    zhucexy () {
      this.zhucexieyi = true
    },
    // 滑块
    init () {
      var that = this
      var nc_token = ['FFFF0N0000000000805E', (new Date()).getTime(), Math.random()].join(':')
      var NC_Opt =
            {
              renderTo: '#your-dom-id',
              appkey: 'FFFF0N0000000000805E',
              scene: that.sceneaa,
              token: nc_token,
              // cons
              customWidth: 300,
              trans: {'key1': 'code0'},
              elementID: ['usernameID'],
              is_Opt: 0,
              language: 'cn',
              isEnabled: true,
              timeout: 3000,
              times: 5,
              apimap: {
              },
              callback: function (data) {
                that.$cookieStore.setCookie('nc_token', nc_token, 600)
                that.$cookieStore.setCookie('csessionid', data.csessionid, 600)
                that.$cookieStore.setCookie('sig', data.sig, 600)
              }
            }
      var nc = new noCaptcha(NC_Opt)
      nc.upLang('cn', {
        _startTEXT: '请拖动滑块进行验证',
        _yesTEXT: '验证通过,<a href="javascript:__nc.reset()">点击刷新</a>',
        _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
      })
    }

  },
  created: function () {
    // 邀请码键盘事件
    var that = this
    document.onkeyup = function (e) {
      var key = window.event.keyCode
      if (that.shuru.invitation.length == 4) {
        that.shuru.invitation += '—'
      }
      that.shuru.invitation = that.shuru.invitation.toUpperCase()
    }
    // 判断浏览器的宽度
    if (document.body.clientWidth < 750) {
      this.sceneaa = String('nc_other_h5')
    } else {
      this.sceneaa = String('nc_other')
    }
  },
  mounted () {
    this.init()
    // 获取地址后边的参数
    this.canshu = (this.$Request.invitecode)
    if (this.canshu === undefined) {
      this.shuru.invitation = ''
    } else {
      if ((this.canshu).length == 17) {
        var cans = (this.canshu).substring(0, 17)
        var canshuq = cans.substring(0, 4)
        var canshuh = cans.substring(13, 17)
        var canshu = canshuq + '—' + canshuh
        this.shuru.invitation = canshu.toUpperCase()
        this.yaoqm = true
      } else if ((this.canshu).length == 8) {
        var cans = (this.canshu).substring(0, 8)
        var canshuq = cans.substring(0, 4)
        var canshuh = cans.substring(4, 8)
        var canshu = canshuq + '—' + canshuh
        this.shuru.invitation = canshu.toUpperCase()
        this.yaoqm = true
      }
    }
  },
  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>
<style scoped>
.shifou {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
.shifou .shifoua {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0.5;
}
.shifou .shifoub {
  padding: 30px;
  width: 300px;
  height: 150px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -105px;
  margin-left: -180px;
}
.upload-demo {
  margin-left: 270px;
  margin-bottom: 20px;
}
#Register {
  background: #f2f2f2;
  padding-bottom: 100px;
}
#Register > img {
  display: block;
  width: 100%;
  height: 200px;
  margin: 0 auto;
}
#Register .header {
  width: 100%;
  height: 60px;
  background: #fff;
  margin-bottom: 60px;
}
#Register .header .logo {
  margin-left: 20px;
  display: block;
  width: 8rem;
  height: 60px;
}
#Register .header .logo img {
  width: 100%;
  height: auto;
  margin-top: 15px;
}
#Register .header .Return {
  width: 90px;
  font-size: 16px;
  height: 32px;
  line-height: 32px;
  margin-top: 13px;
  font-weight: bold;
}
#Register .header .Return:hover {
  color: #295ca4;
}
#Register .header .Return img {
  width: 32px;
  height: 32px;
  vertical-align: bottom;
  margin-right: 5px;
}
#Register .header p {
  width: 100%;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  font-size: 1.625rem;
  margin-left: -8rem;
}
.signIn {
  width: 37.5rem;
  position: relative;
  margin: 50px auto;
  background: #f2f2f2;
  border: 10px solid #fff;
  padding: 6.25rem;
  border-radius: 10px;
}
.inputm {
  border: 2px solid #dfdfdf;
}
.inputh {
  border: 2px solid #e60012;
  background: #ffe4e4;
}
.signIn .input {
  height: 55px;
  margin-bottom: 20px;
}
.signIn ul {
  width: 300px;
  margin-bottom: 20px;
  margin-left: 290px;
}
.signIn ul li {
  list-style: disc;
  margin-bottom: 10px;
  line-height: 20px;
  font-size: 14px;
}
.signIn .input div {
  position: relative;
}
.signIn .input .fangchenmi {
  width: 18.75rem;
  height: 13px;
  position: absolute;
  top: -14px;
  left: 16.875rem;
  font-size: 0.75rem;
  line-height: 12px;
  z-index: 10;
}
.signIn .input .fangchenmi .why {
  display: block;
  padding: 0.625rem;
  width: 17.5rem;
  height: 80px;
  border: 1px solid #dfdfdf;
  position: absolute;
  top: 14px;
  left: 0;
  color: #3d3d3d;
  background: #fff;
  line-height: 20px;
}

.signIn .input p {
  width: 268px;
  line-height: 55px;
  height: 55px;
  font-size: 0.875rem;
  font-weight: bold;
}
.signIn .input input {
  display: block;
  padding: 6px 0.875rem;
  width: 18.75rem;
  height: 24px;
  border-radius: 5px;
}
.signIn .input span {
  position: absolute;
  top: 40px;
  left: 16.75rem;
  font-size: 0.75rem;
  color: #e60012;
}
.signIn .pic ul {
  margin-bottom: 10px;
}
.signIn .pic li {
  list-style: disc;
  text-align: left;
  line-height: 18px;
}
.signIn .checkboxa {
  overflow: hidden;
  padding: 30px 0;
  border-top: 2px solid #dfdfdf;
  border-bottom: 2px solid #dfdfdf;
}
.signIn .checkboxa input {
  width: 1.25rem;
  height: 20px;
  border: 2px solid #dfdfdf;
  border-radius: 10px;
  margin-right: 0.625rem;
}
.signIn .checkboxa p {
  width: 35rem;
  display: inline-block;
  color: #3c3c39;
  font-size: 1rem;
}
.signIn .checkboxa a {
  font-weight: bold;
}
.Registerbtnm {
  background: #b1b1b1;
}
.Registerbtnl {
  background: #295ca4;
}
.signIn .Registerbtn a {
  width: 6.875rem;
  height: 18px;
  display: block;
  padding: 9px 1.25rem;
  border: 1px solid #b1b1b1;
  border-radius: 19px;
  color: #fff;
  text-align: center;
  margin: 30px auto;
}
.signIn .Registerbtn p {
  text-align: center;
}
.signIndenglu {
  height: 12.5rem;
  margin-top: -15.625rem;
}
.demo-ruleForm .dengLu {
  width: 18.75rem;
  display: flex;
  justify-content: space-around;
  margin-left: 5rem;
}
.demo-ruleForm .dengLu a {
  display: inline-block;
  font-size: 0.75rem;
  margin-top: 20px;
}
/* 为什么要填写身份证号 */
.yanzheng {
  width: 18.75rem;
  height: 1.125rem;
  margin-left: 6.25rem;
  position: relative;
}
.yanzheng p {
  font-size: 0.75rem;
}
.yanzheng .tianxie {
  float: left;
}
.yanzheng .why {
  float: right;
  color: red;
}
.yanzheng .txcont {
  width: 18.75rem;
  position: absolute;
  top: 1.375rem;
  right: 0;
  z-index: 21;
  border: 1px solid #c7c7c7;
  line-height: 20px;
  padding: 0.625rem;
  background: #fff;
}
.yanzheng .txcont img {
  width: 0.8125rem;
  height: 0.5rem;
  position: absolute;
  top: -0.5rem;
  right: 1.5625rem;
}
/* 注册协议 */
#xykjxieyi {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  background: #fff;
}
#xykjxieyi .xieyi {
  border: 2px solid #999;
  padding: 20px 1.25rem 20px 1.25rem;
  text-align: left;
  width: 37.5rem;
  height: 500px;
  position: absolute;
  top: 3.125rem;
  left: 50%;
  margin-left: -20rem;
  overflow-y: scroll;
}
#xykjxieyi .xieyi .btn {
  width: 12.5rem;
  height: 3.125rem;
  margin: 2.5rem auto;
}
#xykjxieyi .xieyi .btn button {
  width: 9.375rem;
  height: 3.125rem;
  background: #007bff;
  color: #fff;
  font-size: 1.25rem;
}
.wwww {
  width: 9.375rem;
  float: left;
}
.fasong {
  width: 7.5rem;
  float: left;
  height: 1.875rem;
  font-size: 0.875rem;
  padding: 0 0.625rem;
  margin-top: 5px;
  margin-left: 1.25rem;
}
.marglef {
  margin-left: 1.875rem;
}
.mang_anto {
  margin: 0 auto;
}
.disblk {
  display: block;
}
.huakuai {
  margin-left: 6.25rem;
}
@media screen and (max-width: 750px) {
  .upload-demo {
    margin-left: 0;
  }
  #Register {
    width: 100%;
  }
  .signIn {
    width: 300px;
    padding: 5px;
    border: 5px solid #fff;
  }
  #Register .header .logo {
    display: block;
    width: 8rem;
    height: 60px;
    /* background: #e60012; */
  }
  #Register .header p {
    display: none;
  }
  #Register .header .Return {
    width: 5.625rem;
    font-size: 1rem;
    height: 2rem;
    line-height: 2rem;
    margin-top: 17px;
    font-weight: bold;
  }
  #Register .header .Return span {
    display: block;
    height: 2rem;
  }
  #Register .header .Return:hover {
    color: #295ca4;
  }
  #Register .header .Return img {
    width: 2rem;
    height: 2rem;
    vertical-align: bottom;
    margin-right: 5px;
  }
  .signIn .input {
    height: 95px;
  }
  .signIn .input input {
    width: 275px;
  }
  .signIn .input span {
    position: absolute;
    top: 95px;
    left: 0;
    font-size: 0.75rem;
    color: #e60012;
  }
  .from {
    width: 300px;
    margin: 0;
  }
  .signIn .checkboxa p {
    width: 270px;
  }
  .signIn .checkboxa {
    width: 300px;
    /* margin-top: 200px; */
  }
  .signIn .input .fangchenmi {
    /* width: 18.75rem; */
    position: absolute;
    top: 40px;
    left: 0;
  }
  .signIn ul {
    width: 300px;
    margin-bottom: 20px;
    margin-left: 0;
  }
  /* 协议 */
  #xykjxieyi .xieyi {
    border: 2px solid #999;
    padding: 20px 1.25rem 20px 1.25rem;
    text-align: left;
    width: 300px;
    height: 400px;
    position: absolute;
    top: 3.125rem;
    left: 50%;
    margin-left: -167px;
    overflow-y: scroll;
  }
  #xykjxieyi .xieyi .btn {
    width: 12.5rem;
    height: 3.125rem;
    margin: 2.5rem auto;
  }
  #xykjxieyi .xieyi .btn button {
    width: 9.375rem;
    height: 3.125rem;
    background: #007bff;
    color: #fff;
    font-size: 1.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue